module.exports = __webpack_public_path__ + "static/img/integral_img2.e6f51a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integral_img2.png
// module id = by8a
// module chunks = 55